export { default, type HeadingProps } from './heading';
export { default as HeadingContextProvider } from './heading-context';
